import { render, staticRenderFns } from "./FrmManagePermissions.vue?vue&type=template&id=124f25be"
import script from "./FrmManagePermissions.vue?vue&type=script&lang=js"
export * from "./FrmManagePermissions.vue?vue&type=script&lang=js"
import style0 from "./FrmManagePermissions.vue?vue&type=style&index=0&id=124f25be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports